<template>
  <v-container fluid>
    <v-row>
      <v-col class="pb-0" >
        <v-tabs v-model="tabs" center-active fixed-tabs>
          <v-tab>상세정보</v-tab>
          <v-tab>고장정보</v-tab>
        </v-tabs>
      </v-col>
      <v-col class="pb-0" cols="2">
        <v-select
          outlined
          solo
          dense
          hide-details
          @change="changeSubComp"
          :items="comboList"
          v-model="select"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0" >
        <v-tabs-items
          v-model="tabs"
        >
          <v-tab-item>
            <v-container class="pa-0" fluid>
              <v-row>
                <v-col>
                  <p>인버터 현재상태</p>
                  <v-simple-table
                    fixed-header
                  >
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-center" colspan="2">ESS 인버터 1</th>
                      </tr>
                      <tr>
                        <td class="text-center">
                          <p></p>
                          <v-chip class="px-10">출력전력</v-chip>
                          <p class="mb-0"></p>
                          <span class="big_txt">{{EPCS.EPCS_RefFB}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;kW</span>
                        </td>
                        <td class="text-center">
                          <p></p>
                          <v-chip class="px-12">상태</v-chip>
                          <p class="mb-0"></p>
                          <span class="big_txt">{{EPCS.EPCS_CDStatus_NAME === undefined ? '&nbsp;' :EPCS.EPCS_CDStatus_NAME}}</span>
                        </td>
                      </tr>
                      </thead>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-simple-table
                    fixed-header
                  >
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-center">총 누적충전량</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_TotChaEnergy}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;MWh</span>
                        </td>
                        <th class="text-center">총 누적방전량</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_TotDisEnergy}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;MWh</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">충전 전력</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_ActPower}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;MWh</span>
                        </td>
                        <th class="text-center">방전 전력</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_ReActPower}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;MWh</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">일간 누적충전량</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_DayChaEnergy}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;MWh</span>
                        </td>
                        <th class="text-center">일간 누적방전량</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_DayDisEnergy}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;MWh</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">전월 충전량</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_AfterMonth_PC}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;MWh</span>
                        </td>
                        <th class="text-center">당월 충전량</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_CurrentMonth_PC}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;MWh</span>
                        </td>
                      </tr>
                      <tr>
                      </tr>
                      <tr>
                        <th class="text-center">전월 방전량</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_AfterMonth_P}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;MWh</span>
                        </td>
                        <th class="text-center">당월 방전량</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_CurrentMonth_P}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;MWh</span>
                        </td>
                      </tr>
                      </thead>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p class="pt-3">ESS 인버터 상세정보</p>
                  <v-simple-table
                    fixed-header
                  >
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-center">인버터 상태</th>
                        <th class="text-center">충/방전 상태</th>
                        <th class="text-center">조정모드</th>
                        <th class="text-center">작동모드</th>
                        <th class="text-center">Reference</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_STATUS_NAME}}</span>
                        </td>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_CDStatus_NAME}}</span>
                        </td>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_LocRem_Name}}</span>
                        </td>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_OPmode_Name}}</span>
                        </td>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_RefFB}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;kW</span>
                        </td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-simple-table
                    fixed-header
                  >
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-center">DC-link</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_DCLinkV}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;V</span>
                        </td>
                        <th class="text-center">입력전압</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_DCVolt}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;V</span>
                        </td>
                        <th class="text-center">입력전류</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_DCCurr}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;A</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">입력전력</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_DCPower}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;V</span>
                        </td>
                        <th class="text-center">RS 선간전압</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_Vrs}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;V</span>
                        </td>
                        <th class="text-center">ST 선간전압</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_Vst}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;A</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">RT 선간전압</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_Vrt}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;V</span>
                        </td>
                        <th class="text-center">R상 전류</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_Ir}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;A</span>
                        </td>
                        <th class="text-center">S상 전류</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_Is}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;A</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">T상 전류</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_It}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;A</span>
                        </td>
                        <th class="text-center">주파수</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_Freq}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;Hz</span>
                        </td>
                        <th class="text-center">유효전력</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_ActPower}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;kW</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">무효전력</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_ReActPower}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;kW</span>
                        </td>
                        <th class="text-center">역률</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_PF}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;%</span>
                        </td>
                        <th class="text-center">일간 누적 충전량</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_DayChaEnergy}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;kWh</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">일간 누적 방전량</th>
                        <td class="text-center">
                          <span class="text-body-1">{{EPCS.EPCS_DayDisEnergy}}</span>
                          <span class="text-caption font-weight-thin">&nbsp;&nbsp;MWh</span>
                        </td>
                      </tr>
                      </thead>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container class="pa-0" fluid>
              <v-data-iterator
                :items="breakInfo"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
                <template v-slot:header>
                  <p>ESS 인버터 고장정보</p>
                  <p class="text-body-2">
                    고장정보 체크 시점일
                    <span class="pl-6 text-body-1">{{ nowDate }}</span>
                  </p>
                  <v-divider></v-divider>
                </template>
                <template v-slot:default="props">
                  <v-row>
                    <v-col cols="12"
                           sm="6"
                           lg="3"
                    >
                      <v-row
                        v-for="item in props.items[0]"
                        :key="item.name"
                        cols="12">
                        <v-col class="py-0">
                          <v-card
                            width="350"
                            min-width="310"
                            style="background-color: inherit !important;"
                            class="elevation-0">
                            <v-card-title
                              class="text-subtitle-2">
                              <div
                                class="rounded-circle d-inline-block mr-10"
                                style="width: 25px; height: 25px; background: #d42a46"
                                v-if="item.condition"
                              ></div>
                              <div
                                class="rounded-circle d-inline-block mr-10"
                                style="width: 25px; height: 25px; background: #bdbdbd"
                                v-else
                              ></div>
                              {{item.title}}
                            </v-card-title>
                            <v-divider></v-divider>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="3"
                           sm="6"
                           lg="3"
                    >
                      <v-row
                        v-for="item in props.items[1]"
                        :key="item.name"
                        cols="12">
                        <v-col class="py-0">
                          <v-card
                            width="350"
                            min-width="310"
                            style="background-color: inherit !important;"
                            class="elevation-0">
                            <v-card-title
                              class="text-subtitle-2">
                              <div
                                class="rounded-circle d-inline-block mr-10"
                                style="width: 25px; height: 25px; background: #d42a46"
                                v-if="item.condition"
                              ></div>
                              <div
                                class="rounded-circle d-inline-block mr-10"
                                style="width: 25px; height: 25px; background: #bdbdbd"
                                v-else
                              ></div>
                              {{item.title}}
                            </v-card-title>
                            <v-divider></v-divider>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="3"
                           sm="6"
                           lg="3"
                    >
                      <v-row
                        v-for="item in props.items[2]"
                        :key="item.name"
                        cols="12">
                        <v-col class="py-0">
                          <v-card
                            width="350"
                            min-width="310"
                            style="background-color: inherit !important;"
                            class="elevation-0">
                            <v-card-title
                              class="text-subtitle-2">
                              <div
                                class="rounded-circle d-inline-block mr-10"
                                style="width: 25px; height: 25px; background: #d42a46"
                                v-if="item.condition"
                              ></div>
                              <div
                                class="rounded-circle d-inline-block mr-10"
                                style="width: 25px; height: 25px; background: #bdbdbd"
                                v-else
                              ></div>
                              {{item.title}}
                            </v-card-title>
                            <v-divider></v-divider>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="3"
                           sm="6"
                           lg="3"
                    >
                      <v-row
                        v-for="item in props.items[3]"
                        :key="item.name"
                        cols="12">
                        <v-col class="py-0">
                          <v-card
                            width="350"
                            min-width="310"
                            style="background-color: inherit !important;"
                            class="elevation-0">
                            <v-card-title
                              class="text-subtitle-2">
                              <div
                                class="rounded-circle d-inline-block mr-10"
                                style="width: 25px; height: 25px; background: #d42a46"
                                v-if="item.condition"
                              ></div>
                              <div
                                class="rounded-circle d-inline-block mr-10"
                                style="width: 25px; height: 25px; background: #bdbdbd"
                                v-else
                              ></div>
                              {{item.title}}
                            </v-card-title>
                            <v-divider></v-divider>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import day from 'dayjs'

export default {
  props: {
    site_id: { type: String, default: '' },
    essData: { type: [Object, Object], default: undefined }
  },
  data() {
    return {
      tabs: 0,
      itemsPerPage: 100,
      nowDate: day(Date.now()).format('YYYY-MM-DD HH:mm:ss'),
      select: '',
      description: '',
      item: [],
      EPCS: {
      },
      essResult: []
    }
  },
  watch: {
    essData() {
      this.initData()
    },
    comboList() {
      this.select = this.comboList[0].value
    }
  },
  mounted: function() {
    this.initData()
  },
  computed: {
    comboList() {
      let list = []
      for (let item of this.essResult) {
        if (item.photo === 'PVPCS') {
          list.push({
            text: item.description,
            value: item.codeid
          })
        }
      }
      return list
    },
    breakInfo() {
      return [
        [
          {
            title: 'AC S상 과전류',
            condition: this.EPCS.PVPCS_FAULT1 === '64.0'
          },
          {
            title: 'AC 전압 저전압',
            condition: this.EPCS.PVPCS_FAULT1 === '4096.0'
          },
          {
            title: 'AC 계통 주파수 낮음',
            condition: this.EPCS.PVPCS_FAULT1 === '16384.0'
          },
          {
            title: 'AC 계통 주파수 높음',
            condition: this.EPCS.PVPCS_FAULT1 === '32768.0'
          },
          {
            title: 'AC 퓨즈1 열림',
            condition: this.EPCS.PVPCS_FAULT3 === '1.0'
          },
          {
            title: 'AC 퓨즈2 열림',
            condition: this.EPCS.PVPCS_FAULT3 === '2.0'
          },
          {
            title: 'AC 퓨즈3 열림',
            condition: this.EPCS.PVPCS_FAULT3 === '4.0'
          },
          {
            title: 'AC 퓨즈4 열림',
            condition: this.EPCS.PVPCS_FAULT3 === '8.0'
          },
          {
            title: 'AC 리액터1 과온',
            condition: this.EPCS.PVPCS_FAULT3 === '16.0'
          },
          {
            title: 'AC 리액터2 과온',
            condition: this.EPCS.PVPCS_FAULT3 === '32.0'
          },
          {
            title: 'AC 리액터3 과온',
            condition: this.EPCS.PVPCS_FAULT3 === '64.0'
          },
          {
            title: 'AC 리액터4 과온',
            condition: this.EPCS.PVPCS_FAULT3 === '128.0'
          },
          {
            title: 'AC 리액터1 과열',
            condition: this.EPCS.PVPCS_FAULT3 === '256.0'
          },
          {
            title: 'AC 리액터2 과열',
            condition: this.EPCS.PVPCS_FAULT3 === '512.0'
          },
          {
            title: 'AC 리액터3 과열',
            condition: this.EPCS.PVPCS_FAULT3 === '1024.0'
          },
          {
            title: 'AC 리액터4 과열',
            condition: this.EPCS.PVPCS_FAULT3 === '2048.0'
          },
          {
            title: 'AC 메인 MC 에러',
            condition: this.EPCS.PVPCS_FAULT2 === '8.0'
          },
          {
            title: 'AC 충전 MC 에러',
            condition: this.EPCS.PVPCS_FAULT2 === '32.0'
          },
          {
            title: 'AC전류 오프셋 에러',
            condition: this.EPCS.PVPCS_FAULT1 === '8.0'
          },
          {
            title: 'AC R-S-T상 주파수 에러',
            condition: this.EPCS.PVPCS_FAULT1 === '2048.0'
          },
          {
            title: 'AC R상 과전류',
            condition: this.EPCS.PVPCS_FAULT1 === '1.0'
          },
          {
            title: 'AC T상 과전류',
            condition: this.EPCS.PVPCS_FAULT1 === '32.0'
          },
          {
            title: 'AC전압 과전압',
            condition: this.EPCS.PVPCS_FAULT1 === '8192.0'
          },
          {
            title: 'AC 전류 차이 큼',
            condition: this.EPCS.PVPCS_FAULT1 === '512.0'
          },
          {
            title: 'AC 충전 에러',
            condition: this.EPCS.PVPCS_FAULT1 === '2.0'
          }
        ],
        [
          {
            title: 'DC-link 과전압',
            condition: this.EPCS.PVPCS_FAULT1 === '1.0'
          },
          {
            title: 'DC 전류 오프셋 에러',
            condition: this.EPCS.PVPCS_FAULT1 === '16.0'
          },
          {
            title: 'DC 과전류',
            condition: this.EPCS.PVPCS_FAULT1 === '256.0'
          },
          {
            title: 'DC-link전압 차이 큼',
            condition: this.EPCS.PVPCS_FAULT2 === '1.0'
          },
          {
            title: 'DC 충전 에러',
            condition: this.EPCS.PVPCS_FAULT2 === '4.0'
          },
          {
            title: 'DC충전 MC에러',
            condition: this.EPCS.PVPCS_FAULT2 === '64.0'
          },
          {
            title: 'DC메인 MC에러',
            condition: this.EPCS.PVPCS_FAULT2 === '16.0'
          },
          {
            title: 'DC 리액터1 과열',
            condition: this.EPCS.PVPCS_FAULT3 === '4096.0'
          },
          {
            title: 'DC 리액터2 과열',
            condition: this.EPCS.PVPCS_FAULT3 === '8192.0'
          },
          {
            title: 'DC 리액터3 과열',
            condition: this.EPCS.PVPCS_FAULT3 === '16384.0'
          },
          {
            title: 'DC 리액터4 과열',
            condition: this.EPCS.PVPCS_FAULT3 === '32768.0'
          }
        ],
        [
          {
            title: 'Stack 전류 차이 큼',
            condition: this.EPCS.PVPCS_FAULT1 === '1024.0'
          },
          {
            title: 'Stack1 퓨즈 열림',
            condition: this.EPCS.PVPCS_FAULT2 === '4096.0'
          },
          {
            title: 'Stack2 퓨즈 열림',
            condition: this.EPCS.PVPCS_FAULT2 === '8192.0'
          },
          {
            title: 'Stack3 퓨즈 열림',
            condition: this.EPCS.PVPCS_FAULT2 === '16384.0'
          },
          {
            title: 'Stack4 퓨즈 열림',
            condition: this.EPCS.PVPCS_FAULT2 === '32768.0'
          },
          {
            title: 'Stack1 IGBT 과온',
            condition: this.EPCS.PVPCS_FAULT4 === '1.0'
          },
          {
            title: 'Stack2 IGBT 과온',
            condition: this.EPCS.PVPCS_FAULT4 === '2.0'
          },
          {
            title: 'Stack3 IGBT 과온',
            condition: this.EPCS.PVPCS_FAULT4 === '4.0'
          },
          {
            title: 'Stack4 IGBT 과온',
            condition: this.EPCS.PVPCS_FAULT4 === '8.0'
          },
          {
            title: 'Stack1 팬 단락',
            condition: this.EPCS.PVPCS_FAULT4 === '256.0'
          },
          {
            title: 'Stack2 팬 단락',
            condition: this.EPCS.PVPCS_FAULT4 === '512.0'
          },
          {
            title: 'Stack3 팬 단락',
            condition: this.EPCS.PVPCS_FAULT4 === '1024.0'
          },
          {
            title: 'Stack4 팬 단락',
            condition: this.EPCS.PVPCS_FAULT4 === '2048.0'
          }
        ],
        [
          {
            title: '배터리 과전압',
            condition: this.EPCS.PVPCS_FAULT1 === '4.0'
          },
          {
            title: '배터리 Trip',
            condition: this.EPCS.PVPCS_FAULT4 === '4096.0'
          },
          {
            title: '배터리 저전압',
            condition: this.EPCS.PVPCS_FAULT1 === '2.0'
          },
          {
            title: '배터리 연결 오류',
            condition: this.EPCS.PVPCS_FAULT4 === '16384.0'
          },
          {
            title: '배터리 통신 오류',
            condition: this.EPCS.PVPCS_FAULT4 === '8192.0'
          },
          {
            title: '계통출력 과전압',
            condition: this.EPCS.PVPCS_FAULT2 === '256.0'
          },
          {
            title: '패널 비상 정지',
            condition: this.EPCS.PVPCS_FAULT2 === '128.0'
          },
          {
            title: '패널문 개방',
            condition: this.EPCS.PVPCS_FAULT2 === '512.0'
          },
          {
            title: 'TR 패널문 개방',
            condition: this.EPCS.PVPCS_FAULT2 === '1024.0'
          },
          {
            title: 'TR 과열',
            condition: this.EPCS.PVPCS_FAULT2 === '2048.0'
          },
          {
            title: 'Heat-sink1 과온',
            condition: this.EPCS.PVPCS_FAULT4 === '16.0'
          },
          {
            title: 'Heat-sink2 과온',
            condition: this.EPCS.PVPCS_FAULT4 === '32.0'
          },
          {
            title: 'Heat-sink3 과온',
            condition: this.EPCS.PVPCS_FAULT4 === '64.0'
          },
          {
            title: 'Heat-sink4 과온',
            condition: this.EPCS.PVPCS_FAULT4 === '128.0'
          }
        ]
      ]
    }
  },
  methods: {
    initData() {
      if (this.essData.result !== 'noData') {
        this.item = this.essData
        this.essResult = this.item.essResult

        if (this.essResult.filter(d => d.codenm === 'EPCS01').length > 0) {
          this.description = this.essResult.filter(
            d => d.codenm === 'EPCS01'
          )[0].description
        } else {
          this.description = this.essResult.filter(
            d => d.codenm === 'EPCS10'
          )[0].description
        }

        if (this.item.essData.filter(d => d.EPCS).length !== 0) {
          this.EPCS = this.item.essData.filter(d => d.EPCS)[0].EPCS
        }
      }
    },
    changeSubComp(e) {
      let codeID = e.target.value
      this.description = e.target.desc
      this.EPCS = this.item.essData
        .filter(d => d.EPCS)
        .filter(d => d.EPCS.EPCS_CODEID === codeID)[0].EPCS
    },
    changeTab(key) {
      $("span[name='sub_tab_ess']").removeClass('on')
      $('#tab_ess_' + key).addClass('on')

      $("div[name='ess_tab']").removeClass('on')
      $('#ess_' + key).addClass('on')
    }
  }
}
</script>

<style lang="less" scoped>
.txt-blue {
  color: var(--v-txtblue-base) ;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  /*background-color: var(--v-hth-base);*/
  background-color: var(--v-hth-base);
  border: thin solid var(--v-hthline-base);
  color: var(--v-hthtext-base);
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
  border: thin solid var(--v-hthline-base);
}
</style>
